import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-sbr-nexus-modal',
  templateUrl: './sbr-nexus-modal.component.html',
  styleUrls: ['./sbr-nexus-modal.component.css']
})
export class SbrNexusModal implements OnInit {
  @Input('sbrNexus') sbrNexus: string = 'BTP';
  @Input('environment') environment!: any;
  @Output('updateOrganisationSettings') updateOrganisationSettings: EventEmitter<any> = new EventEmitter<any>();
  
  constructor(private activeModal: NgbActiveModal) { 
  }

  ngOnInit(): void {
  }

  save(){
    this.updateOrganisationSettings.emit([{key:'SBRNexusEnvironment', value:this.sbrNexus}]);
  }

  updateValue(value: string): void {
    this.sbrNexus = value;
  }

  closeDialog() {
    this.activeModal.close(false);
  }
}
